module.exports = __webpack_public_path__ + "img/logo-white.773dc9d7.png";